import useConfirmarReserva from "core/features/reservas/hooks/useConfirmarReserva";
import {
  ListagemReservaResponse,
  StatusReservaEnum,
} from "core/features/reservas/typings";
import { PaginateResult } from "core/resources/types/shared";
import { useLoading } from "infra/helpers/alerta";
import { useMensagemModal } from "ui/components/DrawerNovaMensagem/MensagemModalContext";
import NewTable from "ui/components/NewTable";
import { getDefaultValuesForMessageModal } from "../../util/helper";
import HeaderTable from "./components/HeaderTable";
import useListagemReservasColumns from "./components/useListagemReservaColumns";
import { PermissaoEnum } from "core/resources/enums/permissao";
import { useRegrasTenant } from "core/features/tenants/tenants.context";

interface ReservasTableProps {
  data: PaginateResult<ListagemReservaResponse> | undefined;
  searchValue: string;
  onSearch: (q?: string) => any;
  onPaginate: (p: number, limit: number) => any;
  onRowClick: (reserva: ListagemReservaResponse) => any;
  isLoading?: boolean;
  onEdit?: (id: string) => any;
  onCancel?: (id: string) => any;
  onChangeView?: () => any;
  onShowGuestList?: (reserva: ListagemReservaResponse) => any;
  onShowHistorico?: (id: string) => any;
  refetch?: () => any;
}

function ReservasTable({
  data,
  searchValue,
  onSearch,
  onRowClick,
  isLoading,
  onCancel,
  onChangeView,
  onPaginate,
  refetch,
  onShowGuestList,
  onShowHistorico,
}: ReservasTableProps) {
  const { useSubtenantsViews } = useRegrasTenant();

  const { mutate: confirmarReserva, isLoading: isLoadingConfirmarReserva } =
    useConfirmarReserva();

  useLoading(isLoadingConfirmarReserva);

  const { openWithDefaultValues } = useMensagemModal();
  const columns = useListagemReservasColumns({
    incluirColunaCondominio: useSubtenantsViews,
  });

  return (
    <>
      <NewTable<ListagemReservaResponse>
        title={() => (
          <HeaderTable
            value={searchValue}
            onSearch={onSearch}
            onChangeView={onChangeView}
            view="LISTA"
          />
        )}
        customPagination={{
          onChangePage: onPaginate,
          currentPage: data?.meta.currentPage ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
        }}
        loading={isLoading}
        columns={columns}
        dataSource={data?.items || []}
        onRow={(record) => ({
          onClick: () => onRowClick(record),
          style: {
            cursor: "pointer",
          },
        })}
        actions={[
          // {
          //   title: "Editar",
          //   onClick: (reserva) => onEdit?.(reserva.id),
          // },
          {
            title: "Confirmar",
            onClick: (reserva) => {
              if (!isLoadingConfirmarReserva) {
                confirmarReserva(reserva.id, {
                  onSuccess: () => {
                    refetch?.();
                  },
                });
              }
            },
            permission: PermissaoEnum.Backoffice.Administrativo.Reserva.Aprovar,
            shouldRender: (reserva) =>
              reserva.status.id === StatusReservaEnum.Pendente,
          },

          {
            title: "Enviar mensagem",
            onClick: (reserva) =>
              openWithDefaultValues(getDefaultValuesForMessageModal(reserva)),
          },
          {
            title: "Ver lista de convidados",
            onClick: (reserva) => {
              onShowGuestList?.(reserva);
            },
          },
          {
            title: "Cancelar",
            onClick: (reserva) => onCancel?.(reserva.id),
            permission:
              PermissaoEnum.Backoffice.Administrativo.Reserva.Cancelar,
            shouldRender: (reserva) =>
              reserva.status.id !== StatusReservaEnum.Cancelada,
          },
          {
            title: "Ver boleto",
            onClick: (reserva) => window.open(reserva?.linkBoleto, "blank"),
            shouldRender: (reserva) => !!reserva?.linkBoleto,
          },
          {
            title: "Ver histórico",
            onClick: (reserva) => onShowHistorico?.(reserva.id),
          },
        ]}
      />
    </>
  );
}

export default ReservasTable;
